import { render, staticRenderFns } from "./navbar.item.vue?vue&type=template&id=5ce9c100&scoped=true"
import script from "./navbar.item.vue?vue&type=script&lang=js"
export * from "./navbar.item.vue?vue&type=script&lang=js"
import style0 from "./navbar.item.vue?vue&type=style&index=0&id=5ce9c100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9c100",
  null
  
)

export default component.exports